import { Tooltip, TooltipContent, TooltipTrigger } from "@tracify/ui/tooltip";
import React from "react";
import { cn } from "@/lib/utils";
import InfoIcon from "@tracify/ui/info-icon";
const DirectTooltip = () => {
  return (
    <Tooltip>
      <TooltipTrigger>
        <InfoIcon className={cn("ml-1 h-4 w-4 text-muted-foreground")} />
      </TooltipTrigger>
      <TooltipContent>
        <p className="w-96">
          Direct traffic is the amount of web traffic you receive from users who
          visit your website through a URL directly from their browsers.{" "}
          <a
            href="https://knowledge.tracify.ai/en/articles/92685-what-is-the-difference-between-organic-traffic-and-direct-traffic"
            rel="noreferrer"
            target="_blank"
            className="underline"
          >
            Read more
          </a>
        </p>
      </TooltipContent>
    </Tooltip>
  );
};

export default DirectTooltip;
